import { render } from "./BtnSelect.vue?vue&type=template&id=04c75128&scoped=true"
import script from "./BtnSelect.vue?vue&type=script&lang=js"
export * from "./BtnSelect.vue?vue&type=script&lang=js"

import "./BtnSelect.vue?vue&type=style&index=0&id=04c75128&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c75128"]])

export default __exports__